<template>
  <b-card class="py-5">
    <b-card-title class="text-center">
      <h2>Upload Documents</h2>
    </b-card-title>
    <b-card-body>
      <b-tabs content-class="pt-1" fill pills>
        <b-tab title="General">
          <validation-observer>
            <b-row>
              <b-col
                lg="3"
                md="3"
                sm="12"
                v-if="
                  vendorDetails.vendorType.value ==
                    'labour supply contractor' ||
                  vendorDetails.vendorType.value == 'civil contractor' ||
                  vendorDetails.vendorType.value == 'other'
                "
              >
                <b-form-group>
                  <label for="general-pf-no">
                    PF Number(Provident Fund Number)
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="PF Number"
                    rules="required"
                  >
                    <b-form-input
                      v-model="pfNumber"
                      id="general-pf-no"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                lg="3"
                md="3"
                sm="12"
                v-if="
                  vendorDetails.vendorType.value ==
                    'labour supply contractor' ||
                  vendorDetails.vendorType.value == 'civil contractor' ||
                  vendorDetails.vendorType.value == 'other'
                "
              >
                <b-form-group>
                  <label for="general-pf-certificate"
                    >PF Certificate (Provident Fund)</label
                  >
                  <validation-provider
                    #default="{ errors }"
                    name="PF Certificate"
                    rules="required"
                  >
                    <b-form-file
                      v-model="pfCertificate"
                      id="general-pf-certificate"
                      accept=".jpg, .png, .pdf"
                    >
                    </b-form-file>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                <b-form-group
                  v-if="
                    vendorDetails.vendorType.value ==
                      'labour supply contractor' ||
                    vendorDetails.vendorType.value == 'civil contractor' ||
                    vendorDetails.vendorType.value == 'other'
                  "
                >
                  <label for="general-esic-no"> ESIC Number </label>
                  <validation-provider
                    #default="{ errors }"
                    name="ESIC Number"
                    rules="required"
                  >
                    <b-form-input
                      v-model="esicNumber"
                      id="general-esic-no"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                <b-form-group
                  v-if="
                    vendorDetails.vendorType.value ==
                      'labour supply contractor' ||
                    vendorDetails.vendorType.value == 'civil contractor' ||
                    vendorDetails.vendorType.value == 'other'
                  "
                >
                  <label for="general-pf-certificate">ESIC Certificate</label>
                  <validation-provider
                    #default="{ errors }"
                    name="ESIC Certificate"
                    rules="required"
                  >
                    <b-form-file
                      v-model="esicCertificate"
                      id="general-esic-certificate"
                      accept=".jpg, .png, .pdf"
                    >
                    </b-form-file>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group
                  v-if="
                    vendorDetails.vendorType.value ==
                      'labour supply contractor' ||
                    vendorDetails.vendorType.value == 'other'
                  "
                >
                  <label for="general-entity-no">
                    Entity Registration Number
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Entity Registration Number"
                    rules="required"
                  >
                    <b-form-input
                      v-model="entityNumber"
                      id="general-entity-no"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group
                  v-if="
                    vendorDetails.vendorType.value ==
                      'labour supply contractor' ||
                    vendorDetails.vendorType.value == 'other'
                  "
                >
                  <label for="general-entity-certificate"
                    >Entity Registration Certificate</label
                  >
                  <validation-provider
                    #default="{ errors }"
                    name="Entity Registration Certificate"
                    rules="required"
                  >
                    <b-form-file
                      v-model="entiryCertificate"
                      id="general-esic-certificate"
                      accept=".jpg, .png, .pdf"
                    >
                    </b-form-file>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- <b-col lg="6" md="6" sm="12">
                <b-form-group
                  v-if="
                    vendorDetails.vendorType.value ==
                      'labour supply contractor' ||
                    vendorDetails.vendorType.value == 'other'
                  "
                >
                  <label for="general-pmc-registration"
                    >PMC Registration Number</label
                  >
                  <b-form-input
                    v-model="pmcRegistraionNo"
                    id="general-pmc-registration"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col> -->
            </b-row>
            <br />
            <br />
            <b-row
              v-if="
                vendorDetails.vendorType.value == 'civil contractor' ||
                vendorDetails.vendorType.value ==
                  'material supply contractor' ||
                vendorDetails.vendorType.value == 'electrical contractor' ||
                vendorDetails.vendorType.value ==
                  'electro mechanical contractor'
              "
            >
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="registration-dept">Registration Department</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Regsitration Department"
                    rules="required"
                  >
                    <v-select
                      v-model="registrationDept"
                      id="registration-dept"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Choose Registration Department"
                      :options="registrationDepartments"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="contractor-class">Contractor Class</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Contractor Class"
                    rules="required"
                  >
                    <b-form-input
                      v-model="contractorClass"
                      id="contractor-class"
                      placeholder="Enter Contractor Class"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                <b-form-group>
                  <label for="registration-date">Registration Date</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Registration Date"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="registration-date"
                      v-model="registrationDate"
                      class="mb-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                <b-form-group>
                  <label for="registration-valid"
                    >Registration Valid Up To</label
                  >
                  <validation-provider
                    #default="{ errors }"
                    name="Registration Date"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="registration-valid"
                      v-model="registrationValidUpTO"
                      class="mb-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="registration-number">Registration Number</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Registration Number"
                    rules="required"
                  >
                    <b-form-input
                      v-model="registrationNumber"
                      id="registration-number"
                      placeholder="Enter Registration Number"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="capacity">Bid Capacity</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Capacity"
                    rules="required"
                  >
                    <b-form-input
                      v-model="rCapacity"
                      id="capacity"
                      placeholder="Enter the capacity."
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="registration-document-upload"
                    >Registration Document</label
                  >
                  <b-form-file
                    v-model="registrationDocument"
                    id="registration-document-upload"
                    accept=".jpg, .png, .pdf"
                  >
                  </b-form-file>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-tab>
        <b-tab title="Financial">
          <validation-observer>
            <b-row>
              <b-col lg="4" md="4" sm="12">
                <b-form-group>
                  <label for="finance-doc-type"> Choose Document Type </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Finance Document Type"
                  >
                    <v-select
                      v-model="financialDocType"
                      id="finance-doc-type"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Choose the finance document type"
                      :options="financeDocTypes"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4" md="4" sm="12">
                <b-form-group>
                  <label for="financial-year">Choose Financial Year</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Financial Year"
                  >
                    <v-select
                      v-model="financialyear"
                      id="finance-doc-type"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Choose the finance document type"
                      :options="financialYears"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4" md="4" sm="12">
                <b-form-group>
                  <label for="financial-doc">Upload Financial Document</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Financial Document"
                  >
                    <b-form-file
                      id="financial-doc"
                      accept=".jpg, .png, .pdf"
                      v-model="finDoc"
                    >
                    </b-form-file>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-tab>
        <b-tab title="Machinary">
          <validation-observer>
            <b-row>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="machine-category">Machinary Category</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Machinary Category"
                    rules="required"
                  >
                    <v-select
                      v-model="machinaryCategory"
                      id="machine-category"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Select machine category"
                      :options="machineCategories"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="machine-model-number">Model Number</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Machine Model Number"
                    rules="required"
                  >
                    <b-form-input
                      id="machine-model-number"
                      v-model="machineModelNumber"
                      variant="primary"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="machine-capacity">Capacity</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Capacity"
                    rules="required"
                  >
                    <b-form-input
                      id="machine-capacity"
                      v-model="machineCapacity"
                      variant="primary"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="no-of-machines">No. of Machines</label>
                  <validation-provider
                    #default="{ errors }"
                    name="No of Machines"
                    rules="required"
                  >
                    <b-form-input
                      id="no-of-machines"
                      v-model="noOfMachines"
                      variant="primary"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="machine-category">Select Purchase Year</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Purchase Year"
                    rules="required"
                  >
                    <v-select
                      v-model="yearOfMachinePurchase"
                      id="machine-category"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Select machine purchase year"
                      :options="financialYears"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="select-ownership">Select Ownership</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Ownership"
                    rules="required"
                  >
                    <v-select
                      v-model="machineOwnership"
                      id="select-ownership"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Select Ownership"
                      :options="typeOfOwnership"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="document-description"
                    >Document Description/ Remark</label
                  >
                  <validation-provider
                    #default="{ errors }"
                    name="Document Description / Remark"
                    rules="required"
                  >
                    <b-form-textarea
                      v-model="machineDocumentDescription"
                      id="document-description"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter the description or remark for uploading documents"
                    >
                    </b-form-textarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="machine-docuements">Upload Document</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Uplaod Document"
                    rules="required"
                  >
                    <b-form-file
                      v-model="machineDocuement"
                      id="machine-docuements"
                      accept=".jpg, .png, .pdf"
                    >
                    </b-form-file>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-tab>
        <b-tab title="Labour">
          <validation-observer>
            <b-row>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="labourCategory">Category</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Labour Category"
                    rules="required"
                  >
                    <v-select
                      v-model="labourCategory"
                      id="labourCategory"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Select Labour Category"
                      :options="labourCategories"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="noOfLabours">No. of Labours</label>
                  <validation-provider
                    #default="{ errors }"
                    name="No. Of Labours"
                    rules="required"
                  >
                    <b-form-input
                      type="number"
                      v-model="noOfLabours"
                      placeholder="Enter the number of labours"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="selectLabourYear">Select Year</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Year"
                    rules="required"
                  >
                    <v-select
                      v-model="selectLabourYear"
                      id="selectLabourYear"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Choose the year"
                      :options="financialYears"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="labour-docuement-description"
                    >Document Description/ Remark</label
                  >
                  <validation-provider
                    #default="{ errors }"
                    name="Document Description / Remark"
                    rules="required"
                  >
                    <b-form-textarea
                      v-model="labourDocumentDescription"
                      id="labour-docuement-description"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter the description or remark for uploading documents"
                    >
                    </b-form-textarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                  <label for="labour-docuements">Upload Document</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Uplaod Document"
                    rules="required"
                  >
                    <b-form-file
                      v-model="labourDocuement"
                      id="labour-docuements"
                      accept=".jpg, .png, .pdf"
                    >
                    </b-form-file>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-tab>
        <b-tap title="Work Experiance"></b-tap>
        <b-tap title="Technical Staff"></b-tap>
      </b-tabs>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardBody,
  BTabs,
  BTab,
  BCardText,
  BFormGroup,
  BFormFile,
  BFormInput,
  BButton,
  BContainer,
  BRow,
  BCol,
  BFormDatepicker,
  BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "@validations";

export default {
  props: ["vDetails"],
  components: {
    BCard,
    BCardTitle,
    BCardBody,
    BTabs,
    BTab,
    BCardText,
    BFormGroup,
    BFormFile,
    BFormInput,
    BButton,
    BContainer,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormDatepicker,
    BFormTextarea,
  },
  data() {
    return {
      vendorDetails: this.vDetails,
      financialDocType: "",
      financeDocTypes: [
        { title: "ITR", value: "itr" },
        { title: "Balancesheet", value: "balancesheet" },
        { title: "Turnover", value: "turnover" },
      ],
      financialYear: "",
      financialYears: [
        { title: "2019-2020", value: "2019-2020" },
        { title: "2020-2021", value: "2020-2021" },
        { title: "2021-2022", value: "2021-2022" },
        { title: "2022-2023", value: "2022-2023" },
        { title: "2023-2024", value: "2023-2024" },
        { title: "2024-2025", value: "2024-2025" },
      ],
      finDoc: "",
      pfNumber: "",
      pfCertificate: [],
      esicNumber: "",
      esicCertificate: [],
      entityNumber: "",
      entiryCertificate: [],
      registrationDept: "",
      registrationDepartments: [
        {
          title: "Pune Municipal Corporation",
          value: "Pune Municipal Corporation",
        },
        {
          title: "Public Works Department (PWD)",
          value: "Public Works Department (PWD)",
        },
        {
          title: "Pune Jillha Parishad (ZP)",
          value: "Pune Jillha Parishad (ZP)",
        },
      ],
      contractorClass: "",
      registrationDate: "",
      registrationValidUpTO: "",
      registrationNumber: "",
      rCapacity: "",
      registrationDocument: "",
      pmcRegistraionNo: "",
      machineCategories: [
        { title: "JCB", value: "jcb" },
        { title: "Tractor", value: "tractor" },
      ],
      machinaryCategory: "",
      machineModelNumber: "",
      machineCapacity: "",
      noOfMachines: "",
      yearOfMachinePurchase: "",
      typeOfOwnership: [
        { title: "Owner - (Upload RC Book)", value: "owner" },
        { title: "Rental - (Upload Rent Agreement)", value: "rental" },
      ],
      machineOwnership: "",
      machineDocumentDescription: "",
      machineDocuement: [],
      labourCategories: [{ title: "Painter", value: "painter" }],
      noOfLabours: "",
      selectLabourYear: "",
      labourDocumentDescription: "",
      labourDocuement: [],
    };
  },
  mounted() {
    console.log(this.vendorDetails);
  },
  methods: {
    openPopup() {
      this.$swal({
        title: "Vendor Code Generated Successfully!",
        text: "Your vendor registration code AVIEHT123456LLL is generated successfully.",
        icon: "Success",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        showClass: {
          popup: "animate__animated animate__bounceIn",
        },
        buttonsStyling: false,
      });
    },
  },
};
</script>

<style>
</style>